import { MessageDescriptor } from 'react-intl';

import { ELoyaltyType } from '../../../../model';
import { messages } from '../messages';

export const useDiscountMessage = (type: ELoyaltyType): MessageDescriptor | null => {
  switch (type) {
    case ELoyaltyType.BRAND_DISCOUNT:
      return messages.discountOnBrandText;
    case ELoyaltyType.CATEGORY_DISCOUNT:
      return messages.discountOnCategoryText;
    default:
      return null;
  }
};
